import { render, staticRenderFns } from "./ReportExplanationField.vue?vue&type=template&id=74c9a518&scoped=true&"
import script from "./ReportExplanationField.vue?vue&type=script&lang=js&"
export * from "./ReportExplanationField.vue?vue&type=script&lang=js&"
import style0 from "./ReportExplanationField.vue?vue&type=style&index=0&id=74c9a518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c9a518",
  null
  
)

export default component.exports